<template>
  <div class="card bg-light">
    <div class="card-body">
      <strong>About Us</strong>
      <br /><br />
      <p>
        We're a small startup. <br />
        We believe in next social network. <br />
        We're trying to build a playground where people enjoy their time.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>
